import { getElectronAPI } from "@/plugins/desktop";

export default {
  listar() { return getElectronAPI().vendasGuardadas.listar(); },
  guardar(venda) { return getElectronAPI().vendasGuardadas.guardar(venda); },
  recuperar(uuid) { return getElectronAPI().vendasGuardadas.recuperar(uuid); },
  excluir(uuid) { return getElectronAPI().vendasGuardadas.excluir(uuid); },
};
